import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice"; // Import the user slice
import businessReducer from "./slices/businessSlice"; // Import the user slice
import POSReducer from "./slices/posSlice"; // Adjust the path to your file
import AnnouncementReducer from "./slices/AnnouncementSlice"; // Adjust the path to your file
import BannerReducer from "./slices/BannerSlice"; // Adjust the path to your file
import menuReducer from "./slices/menuSlice"; // ✅ Import your menu slice
import menuItemsReducer from "./slices/MenuItemsSlice"; // path to your slice file
import subscriptionReducer from "./slices/subscriptionSlice"; // Import subscription slice


const store = configureStore({
  reducer: {
    user: userReducer,
    business: businessReducer,
    pos: POSReducer,
    announcements: AnnouncementReducer,
    banners: BannerReducer,
    menu: menuReducer, // ✅ Add it to the store
    menuItems: menuItemsReducer,
    subscriptions: subscriptionReducer, // Add subscriptions reducer
  },
});

export default store;
